import React from 'react';
import Logo from '../components/Logo';

const LogoDownload = () => {
  return (
    <div style={{
      minHeight: '100vh',
      background: '#0a0a0a',
      padding: '60px',
      fontFamily: 'Inter, sans-serif'
    }}>
      <h1 style={{
        fontFamily: 'Playfair Display, serif',
        color: '#D4AF37',
        marginBottom: '10px',
        fontSize: '36px'
      }}>Promesa Trading Logo Downloads</h1>
      <p style={{
        color: '#666',
        marginBottom: '40px',
        fontSize: '14px'
      }}>Right-click on each logo and select &quot;Save Image As...&quot; to download as PNG</p>
      
      <div style={{
        background: '#111',
        padding: '40px',
        marginBottom: '40px',
        border: '1px solid #222'
      }}>
        <h2 style={{
          fontFamily: 'Playfair Display, serif',
          color: '#D4AF37',
          fontSize: '20px',
          marginBottom: '30px'
        }}>Stacked Version - Gold (For Dark Backgrounds)</h2>
        <div style={{
          background: '#000000',
          padding: '80px',
          display: 'inline-block',
          border: '1px solid #1a1a1a'
        }}>
          <Logo variant="footer" color="gold" />
        </div>
        <p style={{
          color: '#999',
          fontSize: '12px',
          marginTop: '15px'
        }}>Use for footer, dark backgrounds, or vertical layouts</p>
      </div>
      
      <div style={{
        background: '#111',
        padding: '40px',
        marginBottom: '40px',
        border: '1px solid #222'
      }}>
        <h2 style={{
          fontFamily: 'Playfair Display, serif',
          color: '#D4AF37',
          fontSize: '20px',
          marginBottom: '30px'
        }}>Stacked Version - Black (For Light Backgrounds)</h2>
        <div style={{
          background: '#ffffff',
          padding: '80px',
          display: 'inline-block',
          border: '1px solid #e0e0e0'
        }}>
          <Logo variant="footer" color="black" />
        </div>
        <p style={{
          color: '#999',
          fontSize: '12px',
          marginTop: '15px'
        }}>Use for light backgrounds, print materials, or presentations</p>
      </div>
      
      <div style={{
        background: '#111',
        padding: '40px',
        marginBottom: '40px',
        border: '1px solid #222'
      }}>
        <h2 style={{
          fontFamily: 'Playfair Display, serif',
          color: '#D4AF37',
          fontSize: '20px',
          marginBottom: '30px'
        }}>Horizontal Version - Gold (For Dark Backgrounds)</h2>
        <div style={{
          background: '#000000',
          padding: '80px',
          display: 'inline-block',
          border: '1px solid #1a1a1a'
        }}>
          <Logo variant="header" color="gold" />
        </div>
        <p style={{
          color: '#999',
          fontSize: '12px',
          marginTop: '15px'
        }}>Use for headers, navigation bars, or horizontal layouts</p>
      </div>
      
      <div style={{
        background: '#111',
        padding: '40px',
        marginBottom: '40px',
        border: '1px solid #222'
      }}>
        <h2 style={{
          fontFamily: 'Playfair Display, serif',
          color: '#D4AF37',
          fontSize: '20px',
          marginBottom: '30px'
        }}>Horizontal Version - Black (For Light Backgrounds)</h2>
        <div style={{
          background: '#ffffff',
          padding: '80px',
          display: 'inline-block',
          border: '1px solid #e0e0e0'
        }}>
          <Logo variant="header" color="black" />
        </div>
        <p style={{
          color: '#999',
          fontSize: '12px',
          marginTop: '15px'
        }}>Use for light backgrounds or alternative color schemes</p>
      </div>
      
      <div style={{
        background: '#1a1a1a',
        padding: '30px',
        marginTop: '60px',
        borderLeft: '3px solid #D4AF37'
      }}>
        <h3 style={{
          color: '#D4AF37',
          fontSize: '16px',
          marginBottom: '15px'
        }}>How to Download:</h3>
        <ol style={{
          color: '#999',
          lineHeight: '2',
          paddingLeft: '20px'
        }}>
          <li>Right-click on the logo you want to download</li>
          <li>Select "Save Image As..." or "Download Image"</li>
          <li>Choose your desired location and save</li>
          <li>The logo will be saved with a transparent background</li>
        </ol>
      </div>
    </div>
  );
};

export default LogoDownload;